/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner } from './get-teams-card-notification-settings200-response-inner-user-accounts-inner-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissue } from './get-teams-card-notification-settings200-response-inner-user-accounts-inner-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser } from './get-teams-card-notification-settings200-response-inner-user-accounts-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup } from './get-teams-card-notification-settings200-response-inner-user-accounts-inner-user-account-group';

/**
 * 
 * @export
 * @interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
 */
export interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'availableCurrencies': Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner>}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'availableMerchantCategories': Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'user': GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser;
    /**
     * 
     * @type {GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'userAccountGroup'?: GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissue}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'reissue'?: GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissue | null;
}

export const GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = typeof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum[keyof typeof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum];


